import { z } from 'zod';
import { inferApiResultSchema, inferPaginatedApiResponse } from './infer-api';
import type { GetAllParamsDto } from './types.dto';

export const demandViewNameLimit = 300;

export type GetAllDemandViewsDto = GetAllParamsDto & { includeDemandCount?: boolean };

export const DemandViewSchema = z.object({
  id: z.number(),
  accountId: z.string().max(50),
  name: z.string().trim().min(1).max(demandViewNameLimit),
  ownerId: z.string().length(24),
  updatedAt: z.coerce.date(),
  createdAt: z.coerce.date(),
  deletedAt: z.coerce.date().nullish(),
  archivedAt: z.coerce.date().nullish(),
  demandCount: z.number().nullish(),
});
export type DemandViewDto = z.infer<typeof DemandViewSchema>;

// GET /api/v1/fim/demand-views/:id
export const GetDemandViewByIdResponseSchema = inferApiResultSchema(DemandViewSchema);
export type GetDemandViewByIdResponseDto = z.infer<typeof GetDemandViewByIdResponseSchema>;

// GET /api/v1/fim/demand-views
export const GetDemandViewsResponseSchema = inferPaginatedApiResponse(z.array(DemandViewSchema));
export type GetDemandViewsResponseDto = z.infer<typeof GetDemandViewsResponseSchema>;

// POST /api/v1/fim/demand-views
export const CreateDemandViewSchema = DemandViewSchema.omit({
  id: true,
  accountId: true,
  ownerId: true,
  createdAt: true,
  updatedAt: true,
  deletedAt: true,
  archivedAt: true,
  demandCount: true,
});
export type CreateDemandViewDto = z.infer<typeof CreateDemandViewSchema>;
export const CreateDemandViewResponseSchema = inferApiResultSchema(DemandViewSchema);
export type CreateDemandViewResponseDto = z.infer<typeof CreateDemandViewResponseSchema>;
